// extracted by mini-css-extract-plugin
module.exports = {"divider":"BlogIndexHeader_divider__lPDB4","subheading":"BlogIndexHeader_subheading___QXo7"};